import React, { useState } from "react";
import { RCCButton, RCCChartPieChart, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import objectToPieChartData from "src/utils/objectToPieChartData";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { IDashboardActionsDataPieChart } from "../../Actions/interface";
import colorChart from "./interface";
import {  HeaderPieChartItem, PieChartItem, WrapperPieChartItem, WrapperPieCharts} from "./styles";

const DashboardPieChartRisksProbability: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [dataRisksOpportunities, setDataRisksOpportunities] = useState<IDashboardActionsDataPieChart[] | undefined>(undefined);
	const [dataRisksThreats, setDataRisksThreats] = useState<IDashboardActionsDataPieChart[] | undefined>(undefined);

	const translateNameActions = (name: string) => {
		switch(name){
		case "high":
			return translate("Alto");
		case "low":
			return translate("Baixo");
		case "moderate":
			return translate("Moderado");
		case "veryHigh":
			return translate("Muito alto");
		case "veryLow":
			return translate("Muito baixo");
		default:
			return "";
		}
	};

	const {loading} = useEffectFetchData<any> (
		"DashboardRisks/ListRisksByProbabilityForPieChart", {},
		({ data }) => {
			// opportunities
			const dataOpportunities = objectToPieChartData(data[0]);
			const translateArrayOpportunities = dataOpportunities.filter((x) => x.name !== "total").map((x) => ({
				...x,
				name: translateNameActions(x.name)
			}));
			setDataRisksOpportunities(translateArrayOpportunities);

			// threats
			const dataThreats = objectToPieChartData(data[1]);
			const translateArrayThreats = dataThreats.filter((x) => x.name !== "total").map((x) => ({
				...x,
				name: translateNameActions(x.name)
			}));
			setDataRisksThreats(translateArrayThreats);
		}
	);
	
	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Gráfico Riscos por Probabilidade")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to="/risks/panel">
					<RCCTooltip
						text={translate("Painel de Riscos")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="risks"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to="/risks/matrix">
					<RCCTooltip
						text={translate("Matriz de Riscos")}
						color="grey"
					>
						<RCCButton 
							color="transparent"
							icon={{
								name: "table",			
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>

			<WrapperPieCharts>
				<WrapperPieChartItem>
					<HeaderPieChartItem>
						<Title color="purple" size="sm">
							{translate("Oportunidades")}
						</Title>
					</HeaderPieChartItem>
					<PieChartItem hiddenUl>
						{dataRisksOpportunities && dataRisksThreats && (
							<>
								<RCCChartPieChart
									width={250}
									height={400}
									showLegend
									pie={[{
										data: dataRisksOpportunities,
										isAnimationActive: true,
										label: true,
										showTotal: true
									}]}
									colorsPallete={colorChart}
								/>
							</>
						)}
					</PieChartItem>
				</WrapperPieChartItem>
				<WrapperPieChartItem>
					<HeaderPieChartItem>
						<Title color="purple" size="sm">
							{translate("Ameaças")}
						</Title>
					</HeaderPieChartItem>
					<PieChartItem>
						{dataRisksThreats && (
							<>
								<RCCChartPieChart
									width={250}
									height={400}
									pie={[{
										data: dataRisksThreats,
										isAnimationActive: true,
										label: true,
										showTotal: true
									}]}
									colorsPallete={colorChart}
								/>
							</>
						)}
					</PieChartItem>
				</WrapperPieChartItem>
			</WrapperPieCharts>

		
			
		</DefaultContainer>
	);
};

export default DashboardPieChartRisksProbability;
